<template>
  <el-row class="tac">
    <div style="text-align: center;height: 48px;line-height: 54px;" @click="isCollapse=!isCollapse">
      <i class="iconfont el-icon-s-operation" style="font-size: 24px !important;"></i>
    </div>
    <el-menu
      :collapse="isCollapse"
      default-active="1"
      :collapse-transition="false"
      class="el-menu-vertical-demo"
      @open="handleOpen"
      @close="handleClose"
      :unique-opened="true"
      background-color="#23262c"
      text-color="#b8c7ce"
      active-text-color="#fff"
      style="height: 100%;"
    >

      <!--撑开左侧框-->
      <div style="width: 220px"></div>


      <template
                v-for="(item, key) in TreeList.submenu"
      >
        <router-link
          :to="item.url"
          :key="key"
          v-if="item.submenu.length==0"
        >
          <el-menu-item    :index="key + 2 + ''">
            <i class="iconfont  " :class="[item.ico]"></i>
            <span slot="title"> {{ item.title }}</span>
          </el-menu-item>
        </router-link>
        <el-submenu
           v-else
          :index="key + 1 + ''"
          :key="key"
        >
          <template slot="title">
            <i class="iconfont " :class="[item.ico]"></i>
            <span>{{ item.title }}</span>
          </template>
          <router-link
            :to="item2.url"
            v-for="(item2, key2) in item.submenu"
            :key="key2"
          >
            <el-menu-item :index="key + 1 + '-' + (key2 + 1)">
              <i class="iconfont  " :class="[item2.ico]"></i> {{ item2.title }}
            </el-menu-item>
          </router-link>
        </el-submenu>
      </template>


      <!--<router-link to="/Order">-->
        <!--<el-menu-item index="998">-->
          <!--<i class="iconfont icon-folder"></i>-->
          <!--<span slot="title">订单管理</span>-->
        <!--</el-menu-item>-->
      <!--</router-link>-->
      <!--<router-link to="/Box">-->
        <!--<el-menu-item index="997">-->
          <!--<i class="iconfont icon-shebeiguanli"></i>-->
          <!--<span slot="title">设备管理</span>-->
        <!--</el-menu-item>-->
      <!--</router-link>-->
      <!--<el-submenu index="996">-->
        <!--<template slot="title">-->
          <!--<i class="iconfont icon-shezhi "></i>-->
          <!--<span>设置</span>-->
        <!--</template>-->
        <!--&lt;!&ndash;<template slot="title">{{item.title}}</template>&ndash;&gt;-->
        <!--&lt;!&ndash;        <router-link to="/Box">&ndash;&gt;-->
        <!--&lt;!&ndash;          <el-menu-item index="995-1">&ndash;&gt;-->
        <!--&lt;!&ndash;            <i class="iconfont icon-shezhi " ></i> 模板管理&ndash;&gt;-->
        <!--&lt;!&ndash;          </el-menu-item>&ndash;&gt;-->
        <!--&lt;!&ndash;        </router-link>&ndash;&gt;-->
        <!--<router-link to="/Log">-->
          <!--<el-menu-item index="995-1">-->
            <!--<i class="iconfont icon-shezhi "></i> 日志管理-->
          <!--</el-menu-item>-->
        <!--</router-link>-->
        <!--<router-link to="/Mould">-->
          <!--<el-menu-item index="995-2">-->
            <!--<i class="iconfont icon-shezhi "></i> 模板管理-->
          <!--</el-menu-item>-->
        <!--</router-link>-->
        <!--<router-link to="/Company">-->
          <!--<el-menu-item index="995-3">-->
            <!--<i class="iconfont icon-shezhi "></i> 公司管理-->
          <!--</el-menu-item>-->
        <!--</router-link>-->

      <!--</el-submenu>-->


    </el-menu>
  </el-row>
</template>

<script>
  export default {
    data() {
      return {
        isCollapse: false,
        TreeList: [],
        Yundan: []
      };
    },
    mounted() {
      this.getTree();
    },
    methods: {
      getTree() {
        //树结构获取
        this.$axios
          .get("https://passport.hzjly.cn/api/Permission/PermissionTree", {
            params: {
              siteguid: "49c92848-ef65-467f-87aa-67e2a43796f9",
              ispower: false
            }
          })
          .then(res => {
            let data = JSON.parse(res.data);
            let ary = data.results.menu[0];
            let other = [];
            ary.submenu.forEach((item, index) => {
              other.push(item);
            });
            data.results.menu[0].submenu = other;

            this.TreeList = data.results.menu[0];

            console.log(this.TreeList);
          })
          .catch(err => {
          });
      },
      handleOpen(key, keyPath) {
        console.log(key, keyPath);
      },
      handleClose(key, keyPath) {
        console.log(key, keyPath);
      }
    }
  };
</script>

<style scoped>
  .el-menu {
    border-right: none;
  }

  .el-menu-item:hover {
    color: #fff !important;
    background-color: #2479f0 !important;
  }

  .is-active {
    background-color: #2479f0 !important;
  }

  .el-menu-item:hover i {
    color: #fff !important;
  }

  /*.el-submenu__title:hover{*/
  /*color:#fff !important;*/
  /*background-color: #2479f0 !important;*/
  /*}*/
  .iconfont {
    margin-right: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Nav.vue